module.exports = __webpack_public_path__ + "img/logo.abc672e2.svg";